import { render, staticRenderFns } from "./PressNotesPg.vue?vue&type=template&id=452fbc48&scoped=true&"
import script from "./PressNotesPg.vue?vue&type=script&lang=js&"
export * from "./PressNotesPg.vue?vue&type=script&lang=js&"
import style0 from "./PressNotesPg.vue?vue&type=style&index=0&id=452fbc48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452fbc48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
